import Vue from "vue";
import Toasted from "vue-toasted";

Vue.use(Toasted);

export function setToasts() {
  // options to the toast
  let options = {
    position: "bottom-center",
    fullWidth: true,
    className: "notificate",
    fitToScreen: true,
    duration: 7000,
    iconPack: "material", // set your iconPack, defaults to material. material|fontawesome|custom-class
    action: {
      text: "Close",
      onClick: (e, toastObject) => {
        toastObject.goAway(0);
      },
    },
    keepOnHover: true,
  };

  // register the toast with a custom message
  return Vue.toasted.register(
    "notificate",
    (payload) => {
      if (payload.type) {
        options.type = payload.type;
        if (payload.type === "error") {
          options.icon = {
            name: "error",
          };
        }
        if (payload.type === "success") {
          options.icon = {
            name: "check",
          };
        }
        if (payload.type === "info") {
          options.icon = {
            name: "info",
          };
        }
      } else {
        options.type = "default";
      }
      if (!payload.message) {
        return "Oops.. Something Went Wrong..";
      }
      return payload.message;
    },
    options
  );
}

export function setWarningToast() {
  let options_one_time = {
    position: "bottom-center",
    className: "notificate",
    fitToScreen: true,
    fullWidth: true,
    iconPack: "material", // set your iconPack, defaults to material. material|fontawesome|custom-class

    action: {
      text: "OK",
      onClick: (e, toastObject) => {
        toastObject.goAway(0);
      },
    },
    keepOnHover: true,
  };

  //register a one time only toast notification
  return Vue.toasted.register(
    "oneTime",
    (payload) => {
      if (payload.type) {
        options_one_time.type = payload.type;
        if (payload.type === "info") {
          options_one_time.icon = {
            name: "info",
          };
        }
      } else {
        options_one_time.type = "default";
      }
      if (!payload.message) {
        return "Oops.. Something Went Wrong..";
      }
      if (payload.source === "profile") {
        window.localStorage.setItem("tipAuPairProfile", "true");
      }
      return payload.message;
    },
    options_one_time
  );
}
